// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import { useEffect, useState } from 'react';

/** How long a load may run before the user is offered a Retry. */
export const SLOW_LOADING_MS = 15_000;

/**
 * True once `loading` has stayed true for `afterMs`, and false again as soon as
 * it ends. For a spinner that would otherwise run forever when a request hangs
 * (AB#35001): the caller keeps the spinner and adds a way out.
 */
export function useSlowLoading(loading: boolean, afterMs: number = SLOW_LOADING_MS): boolean {
  const [slow, setSlow] = useState(false);

  useEffect(() => {
    if (!loading) {
      setSlow(false);
      return undefined;
    }
    const id = setTimeout(() => setSlow(true), afterMs);
    return () => clearTimeout(id);
  }, [loading, afterMs]);

  return loading && slow;
}
